import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LanguageService } from "../services/language.service";

@Injectable({ providedIn: 'root' })
export class CommonLanguageFileResolver implements Resolve<any> {
  constructor(private languageService: LanguageService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    if (route.queryParams && route.queryParams.locale) {
      this.languageService.lang = route.queryParams.locale;
    }
    return this.languageService.getLangFile('common')
      .pipe(
        map(res => res ? res : {}),
        catchError(() => null)
      );
  }
}
